import {combineReducers} from 'redux';
import {customerEmailVerifyReducer } from './customerEmailVerify';
import {getUserCreateInvoceFilesReducer} from './getUserFiles'
/* import {creatInvoiceReducer} from '../../../AddInvoice/store/reducers/createInvoice'
import {getInvoiceReducer} from '../../../AddInvoice/store/reducers/getCurrentInvoice' */
import {getUserExpenseReducer} from './getUserExpense'
import {sendInvoiceEmailReducer} from './sendCustomerReducer'
import {RecoredUserPaymentReducer} from './recorderPaymentReducer'
const reducer = combineReducers({
   RecoredUserPaymentReducer,sendInvoiceEmailReducer,getUserExpenseReducer,customerEmailVerifyReducer,getUserCreateInvoceFilesReducer
    });
    
    export default reducer;

    /* ,creatInvoiceReducer,getInvoiceReducer,getInvoiceReducer */
